var map = {
	"./icon-Increase.svg": 43264,
	"./icon-arrow.svg": 51089,
	"./icon-close.svg": 50829,
	"./icon-ok.svg": 35686,
	"./icon-telegram.svg": 45810,
	"./icon-time.svg": 94375,
	"./icon-twitter.svg": 65765,
	"./icon-warn.svg": 7292,
	"./loading.svg": 66859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;